/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 7/17/15.
 */
'use strict';
angular.module('prism-ui.components.data').factory('ContentResourceFactory', function ($resource, EndPointService) {

	return $resource(EndPointService.contentEndPoint + '/:id' + '/:sub', {
			type: '@type',
			id: '@id',
			sub: '@sub',
			categoryId: '@categoryId',
			fetchOffset: '@fetchOffset',
			fetchLimit: '@fetchLimit',
			view: '@view',
			mvpdPartnerId: '@mvpdPartnerId'
		},
		{
		    getPackageAcceptTemplates: {
		        method: 'GET',
                url: `${EndPointService.contentEndPoint}/:id/mediaProfiles`,
                isArray: true
            },
            updatePackageAcceptTemplates: {
                method: 'PUT',
                url: `${EndPointService.contentEndPoint}/:id/mediaProfiles`,
                isArray: true
            },
            getActorsByContent: {
                method: 'GET',
                    url: `${EndPointService.contentEndPoint}/:id/actors`,
                    params: {
                    seasonId: '@seasonId'
                },
                isArray: true
            },
            saveActorByContent: {
                method: 'POST',
                url: `${EndPointService.contentEndPoint}/:id/actors`,
                isArray: false
            },
            deleteActorsByContent: {
                method: 'DELETE',
                url: `${EndPointService.contentEndPoint}/:id/actors`,
                isArray: true
            },
			getMVPDContent: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/:id',
				params: {id: '@id', mvpdPartnerId: '@mvpdPartnerId'},
				isArray: false
			},
			getContentCategories: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/:id/categories',
				params: {id: '@id', categoryId: '@categoryId'},
				isArray: true
			},
			getContentCategory: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/categories/:contentCategoryId',
				params: {contentCategoryId: '@contentCategoryId'},
				isArray: false
			},
			updateContentCategory: {
				method: 'PUT',
				url: EndPointService.contentEndPoint + '/categories/:contentCategoryId',
				params: {id: null, contentCategoryId: '@contentCategoryId'},
				isArray: false
			},
			saveContentCategory: {
				method: 'POST',
				url: EndPointService.contentEndPoint + '/:id/categories',
				params: {id: '@id'},
				isArray: false
			},
			toggleArchive: {
				method: 'DELETE',
				url: EndPointService.contentEndPoint + '/:id',
				isArray: false
			},
			clone: {
				method: 'PUT',
				url: EndPointService.contentEndPoint + '/:id',
				isArray: false
			},
			update: {
				method: 'PUT',
				url: EndPointService.contentEndPoint + '/:id',
				isArray: false
			},
			getGenres: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/genres',
				isArray: true
			},
			getSeasons: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/:contentId/seasons',
				params: {mvpdPartnerId: '@mvpdPartnerId'},
				isArray: true
			},
			getVolumes: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/:contentId/volumes',
				params: {mvpdPartnerId: '@mvpdPartnerId'},
				isArray: true
			},
			getMVPDSeasonContent: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/seasons/:id',
				params: {id: '@id', mvpdPartnerId: '@mvpdPartnerId'},
				isArray: false
			},
			getSeason: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/seasons/:id',
                params: {view: '@view', mvpdPartnerId: '@mvpdPartnerId'},
                isArray: false
			},
			getMVPDVolumeContent: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/volumes/:id',
				params: {id: '@id', mvpdPartnerId: '@mvpdPartnerId'},
				isArray: false
			},
			getVolume: {
				method: 'GET',
				url: EndPointService.contentEndPoint + '/volumes/:id',
				isArray: false
			},
			toggleSeasonVisibility: {
				method: 'DELETE',
				url: EndPointService.contentEndPoint + '/seasons/:seasonId',
				isArray: false
			},
			toggleVolumeVisibility: {
				method: 'DELETE',
				url: EndPointService.contentEndPoint + '/volumes/:volumeId',
				isArray: false
			},
			createSeason: {
				method: 'POST',
				url: EndPointService.contentEndPoint + '/:contentId/seasons',
				isArray: false
			},
			createVolume: {
				method: 'POST',
				url: EndPointService.contentEndPoint + '/:contentId/volumes',
				isArray: false
			},
			updateSeason: {
				method: 'PUT',
				url: EndPointService.contentEndPoint + '/seasons/:seasonId',
				params: {id: null, seasonId: '@seasonId'},
				isArray: false
			},
			updateVolume: {
				method: 'PUT',
				url: EndPointService.contentEndPoint + '/volumes/:volumeId',
				params: {id: null, volumeId: '@volumeId'},
				isArray: false
			},
			getBranding: {
				method: 'GET',
				isArray: true,
				url: EndPointService.contentEndPoint + '/:id' + '/:view'
			},
			saveBranding: {
				method: 'POST',
				isArray: false,
				url: EndPointService.contentEndPoint + '/:id' + '/:view'
			},
			updateBranding: {
				method: 'PUT',
				isArray: false,
				url: EndPointService.contentEndPoint + '/:id' + '/:view'
			}
		}
	);
});
